import React from 'react';
import { Text, Button, Header, BackButton, Loading, TagPreview } from 'ui';
import { useTagProducts, useAuth, updateTag } from 'api';
import { useHistory, useParams } from 'react-router-dom';
import { pink } from 'config/colors';
import "./index.css";
import customTagsImg from './assets/customShapes.png';

export default function TagProduct() {
  const {tagId} = useParams();
  const auth = useAuth();
  const products = useTagProducts(auth ? auth.company.plan.id : null);
  const history = useHistory();
  
  if(!products || !auth) {
    return <Loading/>;
  }
  
  async function create(product, variant) {
    await updateTag(auth.user.companyId, tagId, {
      product: {
        id: product.id,
        title: product.title,
      },
      variant: {
        id: variant.id,
        title: variant.title,
      }
    });
    history.push("view");
  }
  
  return (
    <div className="tagscreate">
      <Header>
        <BackButton/> <Text large light style={{flex:1}}>Design a Tag</Text>
      </Header>
      <div style={{padding:24}}>
        <Text bold block large style={{marginBottom:12}}>Choose a shape and size</Text>
        
        <div className="tagscreate-products">
          {products.map(product => 
            <div className="tagscreate-product" key={product.id}>
              {product.variants.map(variant => 
                <Button className="tagscreate-variant" key={variant.id} onClick={() => create(product, variant)}>
                  <TagPreview
                    title={variant.title}
                    sizeMult={0.3}
                    variant={variant}
                    style={{boxShadow:'0px 2px 4px rgba(0,0,0,0.3)'}}
                  />
                </Button>
              )}
            </div>
            
          )}
        </div>
        
        <div className="tagscreate-custom">
          <div className="tagscreate-custom-desc">
            <Text bold large block style={{marginBottom:12}}>Custom Shapes and Sizes</Text>
            <Text block style={{marginBottom:8}}>
              Customize your Taptivate tag with your brand’s look and feel. Your logo, your color, your images. Also, choose from an array of shapes and sizes or forward us your customized shape and we’ll bring it to life.
            </Text>
            <Text block>
              To customize the shape of your tag please contact us at <a href="mailto:info@taptivate.co" style={{color:pink}}>info@taptivate.co</a>.
            </Text>
          </div>
          <div className="tagscreate-custom-desc">
            <Text bold block>New Tag Shapes Available as Special Order</Text>
            <Text block>40, 60 and 80 mm</Text>
            <br/>
            <Text block>Contact us at <a href="mailto:info@taptivate.co" style={{color:pink}}>info@taptivate.co</a> for more information</Text>
          </div>
          <div className="tagscreate-custom-preview">
            <img src={customTagsImg} alt="examples"/>
          </div>
        </div>
        
      </div>
    </div>
  );
}


          